/** Formas de receber a renda que o participante pode escolher no requerimento do benefício. */
export enum OpcaoRenda {
  ValorFixoMensal = 'ValorFixoMensal',
  PercentualSaldo = 'PercentualSaldo',
  PrazoCerto = 'PrazoCerto',
  PagamentoUnico = 'PagamentoUnico',
}
